import React, {Component} from 'react'

class GrokPage extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  callGrok = () => {
    alert('hello')
  }

  render() {
    return (
      <div style={{paddingTop: '40px', textAlign: 'center'}}>
        <h1>AI</h1>
        <br/>
        <button onClick={this.callGrok} style={{cursor: 'pointer'}}>Call Grok</button>
      </div>
    )
  }
}


export default GrokPage
